import axios from "axios";

/**
 * URL to send request
 */
const url = process.env.React_App_Api_url;
// const url="http://localhost:5000/user"
/**
 * Get Vendor Data via Store Link
 * @param {String} storeLink Unique store link
 * @returns {Promise} vendorData || error
 */
export const getVendorViaLink = (storeLink) =>
  new Promise((resolve, reject) => {
    axios
      .get(`${url}/getVendorViaLink/${storeLink}`)
      .then((res) => resolve(res?.data))
      .catch((err) => reject(err?.response?.data || "Server timed out"));
  });

export const getVendorsViaPin = (pincode, blackList = [""]) =>
  new Promise((resolve, reject) => {
    axios
      .post(`${url}/getVendorsViaPin`, { pin: pincode, blacklist: blackList })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.response?.data || "Server timed out"));
  });

export const getVendorProducts = (hash) =>
  new Promise((resolve, reject) => {
    axios
      .get(`${url}/getVendorProducts/${hash}`)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.response?.data || "Server timed out"));
  });

export const getFreeProducts = (hash) =>
  new Promise((resolve, reject) => {
    axios
      .get(`${url}/getFreeProducts/${hash}`)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.response?.data || "Server timed out"));
  });
export const getCategoriesProduct = (category) =>
  new Promise((resolve, reject) => {
    axios
      .get(`${url}/getCategoriesProduct/${category}`)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err?.response?.data || "Server timed out"));
  });
